import blog1 from '../images/blog1.png'
import blog2 from '../images/blog2.png'
import blog3 from '../images/blog3.png'
import blog4 from '../images/blog4.png'
import blog5 from '../images/blog5.png'
import blog6 from '../images/blog6.png'

const PopularPosts = [
    {
      title: 'How Our Delivery Process Works',
      image: blog1,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
    {
      title: 'How Our Delivery Process Works',
      image: blog2,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
    {
      title: 'How Our Delivery Process Works',
      image: blog3,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
    {
      title: 'How Our Delivery Process Works',
      image: blog4,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
    {
      title: 'How Our Delivery Process Works',
      image: blog5,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
    {
      title: 'How Our Delivery Process Works',
      image: blog6,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
    {
      title: 'How Our Delivery Process Works',
      image: blog1,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
    {
      title: 'How Our Delivery Process Works',
      image: blog2,
      subtext:
        'Ever wondered what happens after you place an order online? We’ll take you behind the scenes of our delivery journey.',
    },
]

export default PopularPosts